import { forwardRef, type HTMLAttributes } from 'react';

import { inputVariants } from '../../inputs/inputVariants';
import { cn } from '../../utils';

export const MultiselectInputBox = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      inputVariants({ variant: 'default' }),
      'flex flex-row items-center px-2 py-1 overflow-hidden h-fit',
      'focus-within:outline focus-within:outline-2 focus-within:outline-primary-100 focus-within:hover:border-grey-10',
      className,
    )}
    {...props}
  />
));
